// actions
export const FILES_ACTION_FETCH = 'files/action/fetch';

export const FILE_ACTION_FETCH = 'file/action/fetch';
export const FILE_ACTION_CLEAR = 'file/action/clear';
export const FILE_ACTION_FETCH_MY_CJK = 'file/action/fetchMyCjk';
export const FILE_ACTION_SAVE = 'file/action/save';
export const FILE_ACTION_CONVERT_TO_PINYIN = 'file/action/convertToPinyin';
export const FILE_ACTION_PARSE_PASTE = 'file/action/parsePaste';
export const FILE_ACTION_NEW_FILE = 'file/action/newFile';
export const FILE_ACTION_DELETE_FILE = 'file/action/deleteFile';
export const FILE_ACTION_IMPORT_FILE = 'file/action/importFile';
export const FILE_ACTION_ADD_MY_CJK = 'file/action/ADD_MY_CJK';
export const FILE_ACTION_REMOVE_MY_CJK = 'file/action/REMOVE_MY_CJK';
export const FILE_ACTION_CAN_HIDE_PINYIN = 'file/action/CAN_HIDE_PINYIN';
export const FILE_ACTION_JOIN_LEFT = 'file/action/JOIN_LEFT';
export const FILE_ACTION_SEPARATE = 'file/action/SEPARATE';
export const FILE_ACTION_CHANGE_PAGE = 'file/action/CHANGE_PAGE';

// getters
export const FILES_GETTER = 'file/getter/files';

export const FILE_GETTER = 'file/getter/file';
export const FILE_GETTER_MY_CJK = 'file/getter/myCjk';
export const FILE_GETTER_MY_CJK_TEMP = 'file/getter/myCjkTemp';
export const FILE_GETTER_LOADING = 'file/getter/loading';
export const FILE_GETTER_IMPORTING = 'file/getter/importing';
export const FILE_GETTER_PARSING = 'file/getter/parsing';
export const FILE_GETTER_FOOTNOTES = 'file/getter/footnotes';
export const FILE_GETTER_FULL_FILE = 'file/getter/fullFile';
export const FILE_GETTER_FULL_FILE_TOTAL_PAGES =
  'file/getter/fullFileTotalPages';
export const FILE_GETTER_CURRENT_PAGE = 'file/getter/currentPage';
export const FILE_GETTER_SELECTEDS = 'file/getter/selecteds';
export const FILE_GETTER_BOOKS_EXHIBITION_TYPE =
  'file/getter/booksExhibitionType';
export const FILE_GETTER_BOOKS_SHOW_PINIYN = 'file/getter/booksShowPinyin';

// mutations
export const FILES_MUTATION_SET = 'files/mutation/SET';

export const FILE_MUTATION_SET = 'file/mutation/SET';
export const FILE_MUTATION_SET_LINE = 'file/mutation/SET_LINE';
export const FILE_MUTATION_SET_LINE_AND_SAVE =
  'file/mutation/SET_LINE_AND_SAVE';

export const FILE_MUTATION_SET_MY_CJK = 'file/mutation/SET_MY_CJK';
export const FILE_MUTATION_SET_MY_CJK_TEMP = 'file/mutation/SET_MY_CJK_TEMP';
export const FILE_MUTATION_FAILURE = 'file/mutation/FAILURE';
export const FILE_MUTATION_UPDATE_PINYIN = 'file/mutation/UPDATE_PINYIN';
export const FILE_MUTATION_UPDATE_CHARACTER = 'file/mutation/UPDATE_CHARACTER';
export const FILE_MUTATION_ADD_EMPTY_BLOCK = 'file/mutation/ADD_EMPTY_BLOCK';
export const FILE_MUTATION_ADD_EMPTY_LINE = 'file/mutation/ADD_EMPTY_LINE';
export const FILE_MUTATION_ADD_LINE = 'file/mutation/ADD_LINE';
export const FILE_MUTATION_REMOVE_BLOCK = 'file/mutation/REMOVE_BLOCK';
export const FILE_MUTATION_REMOVE_LINE = 'file/mutation/REMOVE_LINE';
export const FILE_MUTATION_PASTE_ACTION = 'file/mutation/PASTE_ACTION';
export const FILE_MUTATION_CONCATENATE_LINE = 'file/mutation/CONCATENATE_LINE';
export const FILE_MUTATION_ADD_MY_CJK = 'file/mutation/ADD_MY_CJK';
export const FILE_MUTATION_REMOVE_MY_CJK = 'file/mutation/REMOVE_MY_CJK';
export const FILE_MUTATION_ADD_HIGHLIGHT = 'file/mutation/ADD_HIGHLIGHT';
export const FILE_MUTATION_REMOVE_HIGHLIGHT = 'file/mutation/REMOVE_HIGHLIGHT';
export const FILE_MUTATION_SET_FILE_LOADING = 'file/mutation/SET_FILE_LOADING';
export const FILE_MUTATION_SET_FILE_PARSING = 'file/mutation/SET_FILE_PARSING';
export const FILE_MUTATION_SET_FILE_IMPORTING =
  'file/mutation/SET_FILE_IMPORTING';
export const FILE_MUTATION_SET_CURRENT_PAGE = 'file/mutation/SET_CURRENT_PAGE';
export const FILE_MUTATION_SET_FOOTNOTES = 'file/mutation/SET_FOOTNOTES';
export const FILE_MUTATION_SET_FULL_FILE = 'file/mutation/SET_FULL_FILE';
export const FILE_MUTATION_SET_PINYIN_SPACED =
  'file/mutation/SET_PINYIN_SPACED';
export const FILE_MUTATION_SET_SELECTEDS = 'file/mutation/SET_SELECTEDS';
export const FILE_MUTATION_SET_BOOKS_EXHIBITION_TYPE =
  'file/mutation/SET_BOOKS_EXHIBITION_TYPE';
export const FILE_MUTATION_SET_BOOKS_SHOW_PINYIN =
  'file/mutation/SET_BOOKS_SHOW_PINYIN';
